import './FieldError.css'

export default function FieldError({ error }) {
  if(typeof error !== 'string') return null;
  return <div className='error-message' dangerouslySetInnerHTML={{ __html: error }} />
}
